import * as z from "zod";

export const NotificationTypeEnum = z.enum([
  // System notifications
  "system_maintenance",
  "system_update",
  "system_alert",
  // Order notifications
  "order_created",
  "order_updated",
  "order_completed",
  "order_cancelled",
  // Warranty notifications
  "warranty_expiring",
  "warranty_expired",
  "warranty_claim",
  // Task notifications
  "task_assigned",
  "task_updated",
  "task_completed",
  // Message notifications
  "message_received",
  "message_mention",
]);

export const NotificationSchema = z.object({
  id: z.string().uuid(),
  type: NotificationTypeEnum,
  title: z
    .string()
    .min(1, "Title is required")
    .max(255, "Title must be less than 255 characters"),
  message: z
    .string()
    .min(1, "Message is required")
    .max(2000, "Message must be less than 2000 characters"),
  user_id: z.string().uuid(),
  sender_id: z.string().uuid().optional(),
  is_read: z.boolean().default(false),
  link: z.string().max(255, "Link must be less than 255 characters").optional(),
  metadata: z
    .string()
    .max(1000, "Metadata must be less than 1000 characters")
    .optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createNotificationSchema = NotificationSchema.omit({
  id: true,
  is_read: true,
  created: true,
  updated: true,
}).extend({
  metadata: z
    .record(z.unknown())
    .optional()
    .transform((data) => (data ? JSON.stringify(data) : undefined)),
});

export const updateNotificationSchema = z.object({
  is_read: z.boolean().optional(),
  metadata: z
    .record(z.unknown())
    .optional()
    .transform((data) => (data ? JSON.stringify(data) : undefined)),
});

export const createBulkNotificationsSchema = z.object({
  notifications: z
    .array(createNotificationSchema)
    .min(1, "At least one notification is required"),
});

export const markNotificationsAsReadSchema = z.object({
  notification_ids: z
    .array(z.string().uuid())
    .min(1, "At least one notification ID is required"),
});
